import ModeratorNote from './ModeratorNote';

export const model = {
  ModeratorNote,
};
